module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SECTION 1 – BACKGROUND TO EUROPEAN DEFENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In 1951, six years after Europe was devastated by the Second World War, the French Foreign Minister Robert Schuman proposed that France and West Germany combine their coal and steel industries under an independent, supranational authority. These two nations were joined by Belgium, Italy, Luxembourg and the Netherlands who established the European Coal and Steel Community (ECSC) following the signing of the Treaty of Paris. The ECSC began operating in 1952 and its obvious success led to discussions at Messina in Italy during 1955 for further moves towards European economic integration. As a result of these negotiations the Treaty of Rome was signed in March 1957 establishing the European Economic Community (EEC) with the original six members of the ECSC becoming the founding members.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Treaty of Rome was intended to create a customs union which would allow the free movement of goods, people, capital and services between member states. The treaty also established a common external trade policy and common policies for both agriculture and fisheries. Other articles of the treaty were concerned with preventing the distortion of competition within the Community, the coordination of national economic policies, the humanisation of social policy, and the association of overseas countries with the European Community to increase trade and assist with economic and social development. In addition the signing of the Treaty of Rome established the Community’s institutional structure as follows:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "ul"
  }, [_c('li', {
    staticClass: "li"
  }, [_vm._v("(1) The European Commission")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("(2) The European Council of Ministers")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("(3) The European Parliament")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("(4) The European Court of Justice")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("(5) The Economic and Social Committee")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("(6) The European Investment Bank")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In May 1969 the heads of state of the six original EEC members met at The Hague and decided to widen the scope of the Community. In accordance with the decisions made at the Hague, the Council of Ministers of the by now European Community (EC) agreed that from 1975 the European Community would have its own revenue independent of national contributions. This revenue would be collected from customs duties and agricultural import levies collected at the EC external frontiers and a percentage of national receipts from Value Added Taxes (VAT).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In December 1991 the heads of the EC member states met at Maastricht in the Netherlands to chart the way ahead for the Community during the next decade. At Maastricht it was decided that the EC would work towards the following:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "ul"
  }, [_c('li', {
    staticClass: "li"
  }, [_vm._v("(1) An evolving Federal Structure")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("(2) European currency union")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("(3) Some form of joint foreign and defence policy in a European Union")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("On 1 January 2002 the Euro was introduced and adopted as its national currency by a majority of countries in the European Union (EU).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In October 2004 the EU countries signed a treaty establishing the European Constitution that was designed to streamline decision-making and management in what was by then the 25 member nations of the European Union. After a period of reflection due to citizens in some European countries voting ‘No’ to the proposed Constitution in national referendums it was not until the signing of the Treaty of Lisbon in December 2007 that the Constitutional Treaty (as amended) was finally accepted. In December 2009 the Lisbon Treaty was finally activated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("By 2010 the original six members of the ECSC had become the following 27 members of the European Union:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "83%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0002.jpg",
      "src": "images/e9781783032051_i0002.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Austria; Belgium; Bulgaria; Cyprus (Greek part); Czech Republic; Denmark; Estonia; Finland; France; Germany; Greece; Hungary; Ireland; Italy; Latvia; Lithuania; Luxembourg; Malta; Netherlands; Poland; Portugal; Romania, Slovakia; Slovenia; Spain; Sweden; United Kingdom.")])])])])]), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }), _c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("General Information – Population and Area")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "82%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0003.jpg",
      "src": "images/e9781783032051_i0003.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "83%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0004.jpg",
      "src": "images/e9781783032051_i0004.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "title3"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }), _c('a', {
    attrs: {
      "id": "title4"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("General Information – Financial")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "83%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0005.jpg",
      "src": "images/e9781783032051_i0005.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Notes:")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Source for the majority of the figures is the International Monetary Fund. Exchange rates between currencies are calculated at mid 2010 rates.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Figures are rounded up to the nearest whole number.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) All EU Governments are facing financial problems and it would be realistic to assume that almost all of the above defence budgets will fall by at least 20 per cent during 2011.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) The above figures are not authoritative and had been taken from a number of sources. Many EU countries use different accounting systems to show their defence budgets and the above figures should only be treated as a reasonable guide.")])])])]), _c('a', {
    attrs: {
      "id": "title4"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title4"
    }
  }), _c('a', {
    attrs: {
      "id": "title5"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("General Information – Armed Forces Personnel")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "83%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0006.jpg",
      "src": "images/e9781783032051_i0006.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: In the ’Central’ column figures for Italy include 107.000 Carabinieri. Figures for Luxembourg include 600 Gendarmes and figures for Netherlands include 5,900 Royal Military Constabulary - all under the control of the Ministry of Defence.")])])])]), _c('a', {
    attrs: {
      "id": "title5"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title5"
    }
  }), _c('a', {
    attrs: {
      "id": "title6"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("General Information – Major Army Formations and Equipment Available (Estimate)")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "84%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0007.jpg",
      "src": "images/e9781783032051_i0007.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "82%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0008.jpg",
      "src": "images/e9781783032051_i0008.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) This is our estimate of the number of combat brigades that could be operational within 21 days in each of the above Land Forces. This table does not show the number of combat brigades that might be available for rapid deployment outside of national boundaries.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) The figure for Attack Helicopters shows aircraft specifically designed for land attack operations such as AH-64 Apache, Tiger and Mi-24. It does not show armed helicopters designed for other roles and mounting machine guns and/or ATGW. In some cases these Attack Helicopters are under Air Force Command and not an integral part of the Land Forces.")])])])]), _c('a', {
    attrs: {
      "id": "title6"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title6"
    }
  }), _c('a', {
    attrs: {
      "id": "title7"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("General Information – Maritime Assets")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "83%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0009.jpg",
      "src": "images/e9781783032051_i0009.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "82%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0010.jpg",
      "src": "images/e9781783032051_i0010.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Submarine figures include 3 x French Strategic Nuclear vessels and 4 x UK Strategic Nuclear vessels.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) It would be realistic to assume that at least 40 per cent of the above vessels would be in refit or extended maintenance at any one time.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) UK aircraft carriers were withdrawn from service in December 2010.")])])])]), _c('a', {
    attrs: {
      "id": "title7"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title7"
    }
  }), _c('a', {
    attrs: {
      "id": "title8"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("General Information – Aviation Assets")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "81%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0011.jpg",
      "src": "images/e9781783032051_i0011.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: Many of the air to air refuelling (AAR) aircraft are dual capable for both transport and air to air refuelling.")])])])]), _c('a', {
    attrs: {
      "id": "title8"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title8"
    }
  }), _c('a', {
    attrs: {
      "id": "title9"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("International Comparisons – Population and Area")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "82%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0012.jpg",
      "src": "images/e9781783032051_i0012.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "title9"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title9"
    }
  }), _c('a', {
    attrs: {
      "id": "title10"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("International Comparisons – Financial")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "82%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0013.jpg",
      "src": "images/e9781783032051_i0013.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "title10"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title10"
    }
  }), _c('a', {
    attrs: {
      "id": "title11"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("International Comparisons – Personnel")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "84%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0014.jpg",
      "src": "images/e9781783032051_i0014.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) This figure is for the United States Marine Corps (USMC).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) This figure is for the Chinese Strategic Missile Force.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Japanese Central Command and Support personnel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) This figure is for Command and Support personnel - approximately 80,000 Strategic Missile Force personnel are included in the figure for the Russian Air Force.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(5) Figures do not include paramilitary personnel and US figures do not include approximately 42,000 US Coastguard personnel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(6) The figures in the above table should Ioe treated as a reasonable guide to overall personnel totals and not as an authority.")])])])]), _c('a', {
    attrs: {
      "id": "title11"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title11"
    }
  }), _c('a', {
    attrs: {
      "id": "title12"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("International Comparison – Major Army Formations and Equipment Available (Estimate)")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "81%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0015.jpg",
      "src": "images/e9781783032051_i0015.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Note: (1) Numbers in this column include Armoured, Mechanised, Infantry, Motorised, Airborne, Air Assault and Amphibious Brigades.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Figure for the US include USMC Brigades and equipment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Overall numbers in this table are averages over a number of sources.")])])])]), _c('a', {
    attrs: {
      "id": "title12"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title12"
    }
  }), _c('a', {
    attrs: {
      "id": "title13"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("International Comparisons – Major Naval Vessels")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "83%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0016.jpg",
      "src": "images/e9781783032051_i0016.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Figures for submarines include both attack submarines and strategic nuclear submarines.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) US figures include 22 x Ticonderoga Aegis Cruisers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) Russian Figure includes 5 x Cruisers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) These aircraft carriers are smaller and less capable than their US counterparts.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(5) About half of the EU frigates are probably in refit or extended maintenance at any one time. Expect other nations to have similar totals of vessels that are not available for operations.")])])])]), _c('a', {
    attrs: {
      "id": "title13"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title13"
    }
  }), _c('a', {
    attrs: {
      "id": "title14"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("International Comparisons – Air Force Assets")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "88%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0017.jpg",
      "src": "images/e9781783032051_i0017.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) Figure includes. US Air Force, US Navy and US Marine Corps Aviation aircraft.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Figures are for US Active Force Aircraft.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) All other figures include Naval Aviation.")])])])])]), _c('a', {
    attrs: {
      "id": "title14"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title14"
    }
  }), _c('a', {
    attrs: {
      "id": "title15"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INFORMATION RELATING TO THE TABLES")])])])]), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title15"
    }
  }), _c('a', {
    attrs: {
      "id": "title16"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A variety of sources were used to identify and where possible to verify both the order of battle and the inventory of individual nations. The most important and usually the most accurate source of information was the Ministries of Defence of the nations concerned, some of whom provided us with considerable unclassified information. This core information was then compared with a variety of other sources many of which were contradictory, and where possible we have used our experience and a certain amount of common sense, to provide what we believe is a reasonably accurate account of each nation’s defence assets.")])])])]), _c('a', {
    attrs: {
      "id": "title16"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title16"
    }
  }), _c('a', {
    attrs: {
      "id": "title17"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Personnel")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Personnel figures are constantly changing and the figures that we provide are to the best of our knowledge accurate as at mid 2010. However, many countries are downsizing their conventional Armed Forces for a variety of reasons, amongst which are the lack of a perceived external threat and the impact of the financial crisis.")])])])]), _c('a', {
    attrs: {
      "id": "title17"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title17"
    }
  }), _c('a', {
    attrs: {
      "id": "title18"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Equipment numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("These numbers are derived from a variety of sources which include some figures published by individual Ministries of Defence. They cannot be 100% accurate and should be treated as a guide. Many of the figures are our own estimates, especially when we know that some older systems had been placed in longer term storage.")])])])]), _c('a', {
    attrs: {
      "id": "title18"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title18"
    }
  }), _c('a', {
    attrs: {
      "id": "title19"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Exchange Rates")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The monetary units used throughout this book are Euros and US dollars using a mid 2010 exchange rate of 1.22 US Dollars to one Euro. The majority of financial figures are taken from the latest International Monetary Fund (IMF) reports.\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("One billion = 1,000 million")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("One trillion = 1,000 billion")])])])])]), _c('a', {
    attrs: {
      "id": "title19"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title19"
    }
  }), _c('a', {
    attrs: {
      "id": "title20"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Current Unit Deployments")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In general terms, under Current Unit Deployments we list the detail for deployments that involve at least a platoon sized organisation – approximately 30 personnel.")])])])])]), _c('a', {
    attrs: {
      "id": "title20"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title20"
    }
  }), _c('a', {
    attrs: {
      "id": "title21"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EUROPEAN DEFENCE OVERVIEW")])])])]), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title21"
    }
  }), _c('a', {
    attrs: {
      "id": "title22"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Council of the European Union")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Council of the European Union represents the governments of the Union’s 27 nations in the legislature of the European Union. Each nation provides one minister whose portfolio includes the subject being discussed. In the case of defence – the ministers responsible would attend (in company with their own National European Commissioner). The other legislative body is the European Parliament.")])])])]), _c('a', {
    attrs: {
      "id": "title22"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title22"
    }
  }), _c('a', {
    attrs: {
      "id": "title23"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("European Common Security and Defence Policy (CSDP)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The EU CSDP is the successor to what used to be known as the European Security and Defence Policy (ESDP). As such the CSDP is an important component of the EU’s Foreign and Security Policy (CFSP) and provides the framework for policy and plans relating to all aspects of European defence and security.")])])])]), _c('a', {
    attrs: {
      "id": "title23"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title23"
    }
  }), _c('a', {
    attrs: {
      "id": "title24"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CSDP Objectives – EU Helsinki Headline Goal 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The EU has adopted the following illustrative scenarios which form the basis for force planning to meet the EU Helsinki Headline Goal 2010 proposals:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("Stabilisation, reconstruction and military advice to third world countries")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Separation of parties by force")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Assistance to humanitarian operations")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Conflict Prevention")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Evacuation Operations in a non-permissive environment")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("To ensure that the requirements of the CSDP and the objectives of the Headline Goal 2010 are met, the following command and planning elements have been established:")])])])]), _c('a', {
    attrs: {
      "id": "title24"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title24"
    }
  }), _c('a', {
    attrs: {
      "id": "title25"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("European Political and Security Committee (PSC)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The PSC keeps track of the requirements of the EU’s Common Foreign and Security Policy and defines how those requirements can be incorporated into the Common Security and Defence Policy. Reporting to the Council of the EU the PSC is composed of EU Ambassadors who have the responsibility for providing a coherent response to a crisis or emergency.")])])])]), _c('a', {
    attrs: {
      "id": "title25"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title25"
    }
  }), _c('a', {
    attrs: {
      "id": "title26"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("European Union Military Committee (EUMC)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Under the leadership of its current Chairman General Hakan Syren (Sweden) the EUMC is composed of the Chiefs of Defence of the EU member nations. Under normal circumstances these Chiefs of Defence are represented by officers seconded to the EUMC from each of the EU member nations. The EUMC provides advice and recommendations on all aspects of EU security and defence matters to the PSC.")])])])]), _c('a', {
    attrs: {
      "id": "title26"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title26"
    }
  }), _c('a', {
    attrs: {
      "id": "title27"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Committee for Civilian Aspects of Crisis Management (CIVCOM)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This committee works closely with the EUMC and provides the PSC with information and recommendations relating to all civilian aspects of crisis and emergency management.")])])])])]), _c('a', {
    attrs: {
      "id": "title27"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title27"
    }
  }), _c('a', {
    attrs: {
      "id": "title28"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAIRMAN OF THE EUROPEAN MILITARY COMMITTEE")])])])]), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title28"
    }
  }), _c('a', {
    attrs: {
      "id": "title29"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("General Hakan Syren")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("General Hakan Syren was born on 31 January 1952 in Vaxjo, Sweden. He graduated in 1973 from the Swedish Naval Academy as Lieutenant in the Coast Artillery. His military education includes the Staff Course and the Command and General Staff Course at the Swedish War College in Stockholm. It also includes the Naval Command Course at the US Naval War College in Newport, USA.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("General Syren was appointed as the Chairman of the European Union Military Committee (EUMC) in Brussels in November 2009. Before taking up his present position, General Syren was Supreme Commander of the Swedish Armed Forces for more than five years. His career also includes four years as Chief of Joint Military Intelligence and Security.")])])])]), _c('a', {
    attrs: {
      "id": "title29"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title29"
    }
  }), _c('a', {
    attrs: {
      "id": "title30"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Career")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "14.91%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85.09%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1973-79 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Instructor and Platoon Commander at the Coast Artillery Regiment in Vaxholm (Sweden)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1980-84 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Student at the Swedish War College, Stockholm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1984-88 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Staff Officer at Navy Staff, Stockholm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1988-89 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Student at the Naval War College, Newport, USA")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1989-90 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Teacher of Strategy, Swedish War College, Stockholm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1990-92 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Head of Planning Department, Navy Staff, Stockholm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1992-94 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Commanding Officer Marine Amphibious Battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1994 to 96 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Commanding Officer Coast Artillery Regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1996 to 98 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Head of Operations Planning Department, Swedish Armed Forces Headquarters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1999 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Secretary to the Defence Commission, Ministry of Defence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1999 to 03 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Chief Joint Military Intelligence and Security, Swedish Armed Forces Headquarters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2004 to 09 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Supreme Commander of the Swedish Armed Forces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2009 –")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Chairman of the European Union Military Committee")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In parallel with the positions within the Armed Forces, General Syrén also served as ADC to His Majesty the King of Sweden from 1988 to 1996. He is member of the Royal Society of Naval Sciences and of the Royal Academy of War Sciences.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("General Syren will probably serve as the Chairman of the European Union Military Committee for a period of three years.")])])])]), _c('a', {
    attrs: {
      "id": "title30"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title30"
    }
  }), _c('a', {
    attrs: {
      "id": "title31"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("European Union Military Staff (EUMS)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Working directly to the Chairman of the EUMC the staff is composed of military and civilian personnel who are responsible for planning and coordination of EU security and defence objectives within the framework of the CSDP.")])])])]), _c('a', {
    attrs: {
      "id": "title31"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title31"
    }
  }), _c('a', {
    attrs: {
      "id": "title32"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU Operations Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("During January 2007, the EU Operations Centre was established in Brussels. This Headquarters can command a small force of about 2,000 troops (possibly a Battlegroup).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In addition to the EU Operations Centre, there are 5 x national operational headquarters which have been made available for use by the EU. These are:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("Mont Valerien (Paris)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Northwood (London)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Potsdam (Berlin)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Centocelle ((Rome)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Larissa (Greece)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("For example: EUFOR’s Democratic Republic of the Congo mission uses Potsdam as its Operational Headquarters (OHQ). There is an agreement that where necessary the EU can use NATO capabilities")])])])]), _c('a', {
    attrs: {
      "id": "title32"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title32"
    }
  }), _c('a', {
    attrs: {
      "id": "title33"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Civilian Planning and Conduct Capability (CPCC)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Working directly to the Political and Security Committee (PSC) this group is responsible for the command and control of civilian (non-military) elements of CSDP crisis and emergency related operations.")])])])]), _c('a', {
    attrs: {
      "id": "title33"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title33"
    }
  }), _c('a', {
    attrs: {
      "id": "title34"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("European Defence Agency")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The European Defence Agency (EDA) was established in July 2004 following a unanimous decision by European Heads of State and Government. It was established under the Council Joint Action 2004/5 51/CFSP on the basis of Article 14 of the treaty on the European Union (Maastricht).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The purpose of the European Defence Agency is to support the Member States and the Council of Europe in order to improve European defence capabilities in the field of crisis management, and to sustain and develop the European Security and Defence Policy (ESDP).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The EDA has the following tasks:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("To improve the EU’s defence capabilities in the field of crisis management.")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("To promote European armaments cooperation.")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("To strengthen the European defence industrial and technological base and create a competitive European defence equipment market, in consultation with the Commission.")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("To promote research, in liaison with Community research activities, with a view to strengthening Europe’s industrial and technological potential in the defence field.")])])])]), _c('a', {
    attrs: {
      "id": "title34"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title34"
    }
  }), _c('a', {
    attrs: {
      "id": "title35"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EDA Organisation")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0019.jpg",
      "src": "images/e9781783032051_i0019.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In the longer term the EDA will achieve its goals by:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("Encouraging EU Governments to spend defence budgets on meeting tomorrow’s challenges and not, in their words, yesterday’s threats.")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Helping EU Governments to identify common needs and promoting collaboration to provide common solutions.")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("The EDA is an agency of the European Union and therefore under the direction and authority of the European Council, which issues guidelines to, and receives reports from the High Representative as Head of the Agency. Detailed control and guidance, however, is the responsibility of the Steering Committee.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Steering Committee, the principal decision-making body of the Agency is made up of Defence Ministers from participating Member States (all EU members except Denmark) and a member of the European Commission. In addition to ministerial meetings at least twice a year, the Steering Committee also meets at the level of national armaments directors, national research directors, national capability planners and policy directors.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The EDA’s chief executive (mid 2010) is Alexander Weis a former head of the German National Armaments Directorate who was appointed in May 2007. The EDA Headquarters is in Brussels (Belgium) and there is approximately 100 staff.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Agency had a budget of 31 million Euros (US$38 million) in 2010.")])])])]), _c('a', {
    attrs: {
      "id": "title35"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title35"
    }
  }), _c('a', {
    attrs: {
      "id": "title36"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("European Union Institute for Strategic Studies (EU-ISS)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The EU-ISS is based in Paris, was established in 2002 and is an independent think tank that researches issues relevant to EU defence and security matters. Much of the work is published and the EU-ISS organises conferences and seminars on all aspects of EU related defence and security.")])])])])]), _c('a', {
    attrs: {
      "id": "title36"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title36"
    }
  }), _c('a', {
    attrs: {
      "id": "title37"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU MILITARY STRUCTURES")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following table sets out the main multilateral military structures outside NATO which include European Union members. A number of these also include non-EU countries. In addition, there are many other bilateral military agreements between individual EU member states.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Military agreements between other EU members are a matter for those member states’ governments.")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "44.74%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "55.26%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("EU participants")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EAG – European Air Group")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Belgium, France, Germany, Italy, Spain, UK")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("European Airlift Centre")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Belgium, France, Germany, Italy, Netherlands, Spain,")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UK")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sealift Coordination Centre (Eindhoven)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Netherlands, UK")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("European Amphibious Initiative (including the UK/Netherlands Amphibious Force)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("France, Italy, Netherlands, Spain, UK")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SHIRBRIG – Stand-by High Readiness Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Austria, Denmark, Finland, Ireland, Italy, Lithuania, Netherlands, Norway, Poland, Portugal, Slovenia, Spain, Sweden. (Observers: Czech Republic, Hungary)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SEEBRIG – South-Eastern Europe Brigade")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Greece, Italy, Slovenia")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NORDCAPS – Nordic Coordinated Arrangement for Military Peace Support")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Finland, Sweden, Denmark")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUROCORPS")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Germany, Belgium, Spain, France, Luxembourg")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUROFOR")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("France, Italy, Portugal, Spain")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EUROMARFOR")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("France, Italy, Portugal, Spain")])])])])])])]), _c('a', {
    attrs: {
      "id": "title37"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title37"
    }
  }), _c('a', {
    attrs: {
      "id": "title38"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EUROCORPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Eurocorps was created in 1992 and comprises military contributions from its five framework nations: Belgium, France, Germany, Luxembourg and Spain. The Headquarters is located in Strasbourg (France). Austria, Canada, Greece, Italy, Poland and Turkey have military liaison staff co-located at Eurocorps HQ")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Commander Eurocorps (COMEC) is a Lieutenant General (3 stars). The Deputy Commander (DCOM) is a Major General (2 stars). The staff is directed by the Chief of Staff (COS), also a Major General and he is supported by two Deputy Chiefs of Staff (DCOS) for Operations and Support, both of whom are Brigadier Generals (1 star).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The posts of Commanding General and the other general officers as well as some key functions are filled by EU framework nations on a rotational basis. COMEC, DCOM and COS are always of different nationalities. Their tour of duty generally lasts for two years.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In general terms the Eurocorps is at the disposal of the European Union and available for service in support of NATO. The command language is English.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Eurocorps consists of formations under direct operational control and formations earmarked for assignment during a crisis or emergency:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Under direct operational control:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("Franco German Brigade (GE-FR Bde)")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("Multinational Command Support Brigade (MNCS Bde)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Formations earmarked for assignment during an emergency:")])])]), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title38"
    }
  }), _c('a', {
    attrs: {
      "id": "title39"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("French Contribution")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Etat-Major de Force numéro 3 (EMF3) in Marseille (equivalent to a divisional HQ) composed of:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Armoured Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1 x Mechanised Infantry Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Specialised support units")])])])])]), _c('a', {
    attrs: {
      "id": "title39"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title39"
    }
  }), _c('a', {
    attrs: {
      "id": "title40"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("German Contribution")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The 10th Armoured Division, with its HQ in Sigmaringen, composed of:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("2 x Brigades as required")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Specialised support units")])])])])]), _c('a', {
    attrs: {
      "id": "title40"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title40"
    }
  }), _c('a', {
    attrs: {
      "id": "title41"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Belgian Contribution")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Belgian Operational Command Land, with its HQ in Evere, composed of:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1st Mechanised Brigade in Leopoldsburg")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("7th Mechanised Brigade in Marche-en-Fammene")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Support units")])])])])]), _c('a', {
    attrs: {
      "id": "title41"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title41"
    }
  }), _c('a', {
    attrs: {
      "id": "title42"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Spanish Contribution")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("1st Land Forces Command its HQ in Burgos, composed of:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("10th Mechanised Brigade in Cordoba")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("11th Mechanised Brigade in Badajoz")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("12th Armoured Brigade in Madrid")])])])])]), _c('a', {
    attrs: {
      "id": "title42"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title42"
    }
  }), _c('a', {
    attrs: {
      "id": "title43"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Luxembourg Contribution")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Luxembourg assigns a reconnaissance company composed of about 180 personnel. During operations this unit would be integrated into the Belgian contingent.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("During the past decade the Eurocorps has been involved in operations as follows:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("SFOR (Bosnia) 1999-2000")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("KFOR III (Kosovo) 2000")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ISAF IV (Afghanistan) 2004-2005")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note")]), _vm._v(": If all earmarked national contributions were committed to operations, the Eurocorps would number approximately 60,000 personnel.")])])])]), _c('a', {
    attrs: {
      "id": "title43"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title43"
    }
  }), _c('a', {
    attrs: {
      "id": "title44"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Franco – German Brigade (FGB)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This is a joint formation which consists of both French and German units and under the direct command of the Eurocorps. The Eurocorps was inaugurated in January 1989 and declared operational in October 1991.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The FGB is essentially a wheeled mechanised Brigade. It is the core entry group for Eurocorps operations and in concert with the EU Battlegroups the immediate EU reserve formation.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "66%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0021.jpg",
      "src": "images/e9781783032051_i0021.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Approximately 5,200 personnel")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Notes:")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(1) 3e Regiment de Hussars")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(2) Jagerbataillon 292")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(3) 110e Regiment d’Infanterie")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(4) Panzerartilleriebataillon 295")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(5) Panzerpionierkompanie 500")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(6) Logistic Battalion with: Supply Company; Maintenance Company; Transport Company; Administration & Support Company; HQ & Support Company.")])])])]), _c('a', {
    attrs: {
      "id": "title44"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title44"
    }
  }), _c('a', {
    attrs: {
      "id": "title45"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU Battlegroups")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In the immediate future, the EU plans to be able to provide at least one coherent Battlegroup package at any one time (usually two), to undertake Battlegroup-sized operations in support of the EU Helsinki Headline Goals.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Full Operational Capability (FOC) was reached at the end of 2007 when all Battlegroups became available. The EU now has the capacity to undertake at least two concurrent single Battlegroup-size rapid response operations, including the ability to launch both such operations nearly simultaneously.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("EU Member States have indicated that they will commit to Battle Groups, formed as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "17.05%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "82.95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("United Kingdom")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("France")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("France and Belgium")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Italy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Spain")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("France, Germany, Belgium, Luxembourg and Spain")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Germany, the Netherlands and Finland (BG 107)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Germany, Austria and Czech Republic")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Italy, Hungary and Slovenia")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Spain and Italy (Amphibious)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Italy, Romania and Turkey")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Poland, Germany, Slovakia, Latvia and Lithuania")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sweden, Finland, Estonia, Ireland and Norway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("14")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("United Kingdom and the Netherlands")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("15")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Greece, Bulgaria, Cyprus, Romania and Slovenia")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("16")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Czech Republic and Slovakia")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("17")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x "
  }, [_vm._v("Spain, Germany, France and Portugal")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Expect a battle group to have between 1,500 and 2,000 personnel.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are usually 2 x EU Battlegroups on standby for operations and trained to respond to emerging contingencies at any one time. They would be deployed following a unanimous decision of the European Council of Ministers, with the nations providing the Battlegroup having a veto on any deployment decision.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Each Battlegroup will have a ‘lead nation’ that will take operational command, based on the model set up during the EU’s peacekeeping mission in the Democratic Republic of the Congo (Operation Artemis). Two non-EU NATO countries, Norway and Turkey participate in the EU Battlegroup program.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Battlegroups would have to be able to deploy within 5-10 days and be sustained initially for 30, but possibly up to 120 days while operating up to 6,000 km from Brussels.")])])])]), _c('a', {
    attrs: {
      "id": "title45"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title45"
    }
  }), _c('a', {
    attrs: {
      "id": "title46"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("European Rapid Reaction Force")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("As yet (mid 2010) there is no standing European Rapid Reaction Force (other than the Franco – German Brigade) nor any EU agreement to create one. What has sometimes been referred to as a ‘European Rapid Reaction Force’ is, in fact, a catalogue of forces which member states could make available to the EU should they choose to participate in a particular EU-led operation. Any contribution to a particular EU-led operation would depend on the operation’s requirements, the availability of forces at the time and the willingness of EU members to participate. However, it is likely that this will change during the next five years.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Current EU Military Operations")])])])])])]), _c('a', {
    attrs: {
      "id": "title46"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title46"
    }
  }), _c('a', {
    attrs: {
      "id": "title47"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EUFOR (OPERATION ALTHEA)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The EU launched Operation Althea in Bosnia and Herzegovina (BiH) – in December 2004. This follows the decision by NATO to conclude its SFOR mission.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The EU deployed a large force of 6,300 personnel to ensure continued compliance with the Dayton/Paris Agreement and to contribute to a safe and secure environment in BiH.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The key objectives of Operation Althea are to provide deterrence and continued compliance with the responsibility to fulfil the role specified in Annexes 1A and 2 of the Dayton/Paris Agreement (General Framework Agreement for Peace in BiH) and to contribute to a safe and secure environment in BiH, in line with its mandate, and to achieve core tasks in the Stabilisation and Association Process (SAP).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The headquarters of EUFOR is in Sarajevo and in mid 2010 the personnel strength for Operation Althea was in the region of 1,600.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Operation Althea has been authorised by the United Nations Security Council Resolution 1575’")])])])]), _c('a', {
    attrs: {
      "id": "title47"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title47"
    }
  }), _c('a', {
    attrs: {
      "id": "title48"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EURONAVFOR (OPERATION ATALANTA)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In December 2008, the EU established operation ATALANTA to protect World Food Programme and other vulnerable shipping transiting through the Gulf of Aden. The UK has provided the Operation Commander and Operation Headquarters at Northwood since its inception and will continue to do so until the end of the mandate, which has recently been extended to December 2012.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("EURONAVFOR currently includes warships, support vessels, and the delivery of shipping advice and reassurance from Belgium, Denmark, France, Germany, Greece, the Netherlands and Spain. Maritime Patrol aircraft are provided by Portugal, Spain, Germany, France")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Personnel strength is in the region of 1,290.")])])])]), _c('a', {
    attrs: {
      "id": "title48"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title48"
    }
  }), _c('a', {
    attrs: {
      "id": "title49"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EUTM (SOMALIA)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("During January 2010, the EU established a training mission for Somali security forces which commenced during early May. Training actually takes place in Uganda and EUTM has a personnel strength of around 130.")])])]), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title49"
    }
  }), _c('a', {
    attrs: {
      "id": "title50"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Current EU Civilian Missions (2010)")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_tab"
  }, [_c('div', {
    staticClass: "image_tab",
    staticStyle: {
      "width": "82%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0024.jpg",
      "src": "images/e9781783032051_i0024.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "title50"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title50"
    }
  }), _c('a', {
    attrs: {
      "id": "title51"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EU Relationship with NATO")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In a joint declaration by both the EU and NATO during 2002, a previously slightly confused relationship was clarified under a number of major headings that included partnership, mutual cooperation and consultation, equality and due regard for the autonomy of both the EU and NATO, plus reinforcing and developing the military capability of both organisations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The ‘Berlin Plus Agreement’ of March 2003 allows the EU to use NATO structures to support military operations that do not fall within the remit of NATO responsibilities. In addition, there is considerable exchange of information between both organisations and they are EU/NATO liaison cells situated in the headquarters of both organisations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Because in many cases nations that are members of the EU are also members of NATO, the same forces are often assigned to both EU and NATO missions. It is therefore likely that the EU will only act if NATO first decides that it will not do so.")])])])])]), _c('a', {
    attrs: {
      "id": "title51"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title51"
    }
  }), _c('a', {
    attrs: {
      "id": "title52"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The following nations are members of the North Atlantic Treaty Organisation (NATO) Alliance.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Albania, Belgium, Bulgaria, Canada, Croatia, Czech Republic, Denmark, Estonia, France, Germany, Greece, Hungary, Iceland, Italy, Latvia, Lithuania, Luxembourg, Netherlands, Norway, Poland, Portugal, Romania, Spain, Slovakia, Slovenia, Turkey, United Kingdom, United States. (28)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In 1993, NATO was reorganised from three into two major Commands with a further reorganisation of these two commands in 2003. The first is ACT (Allied Command Transformation) with headquarters at Norfolk, Virginia (USA) and the second is ACO (Allied Command Operations), with its headquarters at Mons in Belgium.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The current Supreme Allied Commander Europe (SACEUR) is Admiral Stavridis. SACEUR, (a US officer) is responsible for the overall command of NATO military operations and conducts the necessary military operational planning, including the identification of forces required for the mission and requesting these forces from NATO countries, as authorised by the North Atlantic Council and as directed by NATO’s Military Committee. Admiral Stavridis was appointed in June 2009.")])])]), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title52"
    }
  }), _c('a', {
    attrs: {
      "id": "title53"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Allied Command Transformation (ACT)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In the future, Allied Command Transformation, with its headquarters in Norfolk, US, will oversee the transformation of NATO’s military capabilities. In doing so, it will enhance training, improve capabilities, test and develop doctrines and conduct experiments to assess new concepts. It will also facilitate the dissemination and introduction of new concepts and promote interoperability. There will be an ACT Staff Element in Belgium primarily for resource and defence planning issues.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ACT commands the Joint Warfare Centre in Norway, a Joint Force Training Centre in Poland and the Joint Analysis and Lessons Learned Centre in Portugal. ACT Headquarters also supervises the Undersea Research Centre in La Spezia, Italy and the NATO School at Oberammergau in Germany. There are direct linkages between ACT, Alliance schools and NATO agencies, as well as the US Joint Forces Command.")])])])]), _c('a', {
    attrs: {
      "id": "title53"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title53"
    }
  }), _c('a', {
    attrs: {
      "id": "title54"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Allied Command Operations (ACO)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Allied Command Operations, with its headquarters, SHAPE, near Mons, Belgium, is responsible for all NATO operations. The levels beneath SHAPE have been significantly streamlined, with a reduction in the number of headquarters. The operational level consists of two standing Joint Force Commands (JFCs) one in Brunssum, the Netherlands, and one in Naples, Italy – which can conduct operations from their static locations or provide a land-based Combined Joint Task Force (CJTF) headquarters, and a robust but more limited standing Joint Headquarters (JHQ), in Lisbon, Portugal, from which a deployable sea-based CJTF HQ capability can be drawn. The current organisation of Allied Command Operations is as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0025.jpg",
      "src": "images/e9781783032051_i0025.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "title54"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title54"
    }
  }), _c('a', {
    attrs: {
      "id": "title55"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Component Headquarters at the Tactical Level")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The component or tactical level consists of six Joint Force Component Commands (JFCCs), which provide service-specific land, maritime, or air expertise to the operational level. Although these component commands will be available for use in any operation, they will be subordinated to one of the Joint Force Commanders.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0026.jpg",
      "src": "images/e9781783032051_i0026.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "title55"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title55"
    }
  }), _c('a', {
    attrs: {
      "id": "title56"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Static Air Operations Centres (CAOC)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In addition to the above component commands there will be four static Combined Air Operations Centres with two more deployable as follows:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "68%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0027.jpg",
      "src": "images/e9781783032051_i0027.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("As the deployable CAOCs will need to exercise their capability to mobilise and deploy, the current facilities at Torrejon Air Base in Spain will probably be the primary site for training and exercising in that region. A small NATO air facility support staff would be stationed at Torrejon to support this capability.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Deployable Immediate Reaction Forces (IRF) available:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Immediate Reaction Forces (Maritime) –")]), _vm._v(" There are four Maritime Immediate Reaction Forces that provide NATO with a continuous naval presence and can be deployed NATO-wide, when required.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ACE (Allied Command Europe) Rapid Reaction Corps (ARRC) – The ARRC is prepared for deployment throughout Allied Command Europe in order to augment or reinforce local forces whenever necessary. The Headquarters of the ARRC is located at Innsworth (near Gloucester) in the UK.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eurocorps HQ –")]), _vm._v(" Based around Strasbourg in France")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Reaction Forces (Air) Staff –")]), _vm._v(" With headquarters at Kalkar in Germany.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACE Mobile Force (AMF) –")]), _vm._v(" With headquarters at Heidelberg in Germany.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Deployable National Corps –")]), _vm._v(" These deployable corps are available with headquarters provided by Italy, Turkey, Germany/Netherlands, Spain and Greece.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO Airborne Early Warning Force (NAEWF) –")]), _vm._v(" The NATO Airborne Early Warning Force provides air surveillance and command and control for all NATO commands. It is based in Geilenkirchen, Germany, and Waddington, United Kingdom.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO Programming Centre (NPC) –")]), _vm._v(" The NATO Programming Centre maintains NATO Air Command and Control Software and provides system expertise to nations and NATO agencies and headquarters. It is located in Glons, Belgium.")])])])])]), _c('a', {
    attrs: {
      "id": "title56"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title56"
    }
  }), _c('a', {
    attrs: {
      "id": "title57"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NATO DEPLOYMENT CONCEPT")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Under this concept, NATO forces should be able to rapidly deploy to crisis areas and remain sustainable, be it within or outside NATO’s territory, in support of both Article 5 and Non-Article 5 operations. The successful deployments of the Allied Command Europe Rapid Reaction Corps (ARRC) to two NATO-led Balkan operations (the Implementation Force (IFOR) to Bosnia Herzegovina in 1995 and Kosovo Force (KFOR) to Kosovo in 1999) are early examples of non-Article 5 crisis response operations outside NATO territory.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Article 5 operations commit each NATO member state to consider an armed attack against one state to be an armed attack against all states. Non-Article 5 operations are operations that are not concerned with collective defence.")])])]), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title57"
    }
  }), _c('a', {
    attrs: {
      "id": "title58"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("High Readiness Forces and Forces of Lower Readiness")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("There are forces of two different kinds of readiness posture; first, forces with a higher state of readiness and availability, the so-called High Readiness Forces (HRF) to react on short notice; second, forces with a lower state of readiness (FLR) to reinforce and sustain. Graduated Readiness Headquarters are being developed to provide these forces with command and control facilities.")])])])]), _c('a', {
    attrs: {
      "id": "title58"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title58"
    }
  }), _c('a', {
    attrs: {
      "id": "title59"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("High Readiness Forces (Land) Headquarters candidates available:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Allied Command Europe Rapid Reaction Corps (ARRC) HQ at Innsworth with the United Kingdom as framework nation;")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Rapid Deployable German-Netherlands Corps HQ, based on the 1st German-Netherlands Corps HQ in Munster (Germany);")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Rapid Deployable Italian Corps HQ based on the Italian Rapid Reaction Corps HQ in Solbiate Olona close to Milan (Italy);")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Rapid Deployable Spanish Corps HQ based on the Spanish Corps HQ in Valencia (Spain);")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Rapid Deployable Turkish Corps HQ based on the 3rd Turkish Corps HQ near Istanbul (Turkey);")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Eurocorps HQ in Strasbourg (France) sponsored by Belgium, France, Germany, Luxembourg and Spain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Note :")]), _vm._v(" The Eurocorps Headquarters which has a different international military status based on the Strasbourg Treaty has signed a technical arrangement with SACEUR and can also be committed to NATO missions.")])])])]), _c('a', {
    attrs: {
      "id": "title59"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title59"
    }
  }), _c('a', {
    attrs: {
      "id": "title60"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Forces of Lower Readiness (Land) Headquarters candidates:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Multinational Corps HQ North-East in Szczecin (Poland) sponsored by Denmark, Germany and Poland;")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Greek ‘C’ Corps HQ near Thessaloniki (Greece).")])])])]), _c('a', {
    attrs: {
      "id": "title60"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title60"
    }
  }), _c('a', {
    attrs: {
      "id": "title61"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("High Readiness Forces (Maritime) Headquarters:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Headquarters Commander Italian Maritime Forces on board of the Italian Naval Vessel GARIBALDI")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Headquarters Commander Spanish Maritime Forces (HQ COMSPMARFOR) on board of LPD CASTILLA")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Headquarters Commander United Kingdom Maritime Forces (HQ COMUKMARFOR) onboard a UK Aircraft Carrier")])])])])]), _c('a', {
    attrs: {
      "id": "title61"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title61"
    }
  }), _c('a', {
    attrs: {
      "id": "title62"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE ALLIED RAPID REACTION CORPS (ARRC)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The concept of the Allied Rapid Reaction Corps was initiated by the NATO Defence Planning Committee in May 1991. The concept called for the creation of Rapid Reaction Forces to meet the requirements of future challenges within the alliance. The ARRC provides the Supreme Allied Commander Europe with a multinational corps sized grouping in which forward elements can be ready to deploy within 14 days (lead elements and recce parties at very short notice).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("As stated by SHAPE the mission of the ARRC is:")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“HQ ARRC, as a High Readiness Force (Land) HQ, is prepared to deploy under NATO, EU or coalition auspices to a designated area, to undertake combined and joint operations across the operational spectrum as:\n")])]), _vm._v(" "), _c('ul', {
    staticClass: "bl"
  }, [_c('li', {
    staticClass: "bsl"
  }, [_vm._v("a Corps HQ")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("a Land Component HQ")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("a Land Component HQ in command of the NATO Response Force")]), _vm._v(" "), _c('li', {
    staticClass: "bsl"
  }, [_vm._v("a Joint Task Force HQ for Land-centric operations")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("These formations will enable crisis support management options or the sustainment of ongoing operations.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Currently the ARRC trains for missions across the spectrum of operations from deterrence and crisis management to regional conflict.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Currently (late 2010) Headquarters ARRC is located at Innsworth (UK), with a peace-time establishment of about 400 personnel. It comprises staff from all the contributing nations. As the Framework Nation, the UK provides the infrastructure, administrative support, communications and 60 per cent of the staff.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Commander (COMARRC) and Chief of Staff are UK 3 Star and 2 Star Generals and the Deputy Commander is an Italian 2 Star General. The other appointments, as with the training and exercise costs, are shared among the contributing nations.")])])]), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title62"
    }
  }), _c('a', {
    attrs: {
      "id": "title63"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Outline Composition of the ARRC (Allied Command Europe Rapid Reaction Corps)")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("For operations HQ ARRC might have some of the following formations under command:")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781783032051_i0028.jpg",
      "src": "images/e9781783032051_i0028.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The operational organisation, composition and size of the ARRC would depend on the type of crisis, area of crisis, its political significance, and the capabilities and availability of lift assets, the distances to be covered and the infrastructure capabilities of the nation receiving assistance. It is considered that a four division ARRC would be the maximum employment structure.")])])])]), _c('a', {
    attrs: {
      "id": "title63"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title63"
    }
  }), _c('a', {
    attrs: {
      "id": "title64"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Command Posts and Deployment")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Due to the need to be able to respond flexibly to the whole range of potential operations, HQ ARRC has developed the capability for rapidly deployable and modular HQs. Deployment begins with the despatch of a Forward Liaison and Reconnaissance Group (FLRG) within 48 hours of the order being given which can then be quickly followed up.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Within four days the key enablers from 1 (UK) Signal Bde would be within theatre and three days later HQ ARRC Forward and HQ Rear Support Command (RSC) Forward – as required – could be established. The forward-deployed HQs are light, mobile and C-130 transportable. While there is a standard ‘default’ setting for personnel numbers, the actual staff composition is ‘tailored’ to the task and can vary from approximately 50 to 150 staff, depending on the requirement. The ‘in-theatre’ task would then be supported by the remainder of the staff, using sophisticated ‘Reachback’ techniques and equipment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Early Entry HQs are capable of sustained independent operations if required but can also be used as enablers if it is decided to deploy the full HQ ARRC. This deployment concept has been tested and evaluated on several exercises and has proven its worth. In parallel, HQ ARRC is continuously looking to make all of its HQs lighter and more survivable.")])])])])])]), _c('a', {
    attrs: {
      "id": "title64"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf994566","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783032051_c01.vue
// module id = 69
// module chunks = 0